import { defineMessages } from 'react-intl';

export default defineMessages({
    raiseRequestText: {
        defaultMessage: 'Need to raise a request? Contact us.',
        description: 'Card button text to raise request',
        id: 'sd.customerview.portal.card.button.text',
    },
});
